import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { SCHEMA_ADDRESS_SHAPE } from 'src/schemas/MyAddressBook';
import { SCHEMA_ORDER_ADDRESS_SHAPE } from 'src/schemas/OrderingAddress';
import { AccountID } from '../organization';

/* Customer Addresses */

export function fetchCustomerAddresses(accountId: AccountID = getCustomerId() as AccountID): Promise<CallApiResult> {
    const endpoint = `/api/customer/${accountId}/addresses`;
    return callApi(endpoint);
}

// TODO: remove legacy name after all imports migrate to fetchCustomerAddresses
export const getCustomerAddresses = fetchCustomerAddresses;

export function submitAddressForm(
    accountId: AccountID = 'current',
    data: SCHEMA_ADDRESS_SHAPE,
    id?: string | number
): Promise<CallApiResult> {
    const preparedData = {
        ...data,
        additionalInvoiceData: data.additionalInvoiceData.filter(d => d.value != null && d.value.length > 0),
    };

    if (id === undefined)
        return callApi(`/api/customer/${accountId}/addresses`, { method: 'POST', data: preparedData });

    return callApi(`/api/customer/${accountId}/addresses/${id}`, { method: 'PUT', data: preparedData });
}

export function submitOrderingAddressForm(
    data: SCHEMA_ORDER_ADDRESS_SHAPE,
    id?: string | number
): Promise<CallApiResult> {
    const preparedData = {
        ...data,
        id,
        additionalInvoiceData: data.additionalInvoiceData.filter(d => d.value != null && d.value.length > 0),
    };
    return callApi(`/api/ordering/address/${'current'}`, { method: 'PUT', data: preparedData });
}
